import { IGroup, ITeacher } from 'entities/types';
import { searchType } from 'features/searchSchedule/models/searchType';
import { OptionLabel } from 'features/searchSchedule/ui';
import { formatFullnameToUppercase } from 'shared/lib';

export const makeOptionLabel = (
  searchType: searchType,
  item: IGroup | ITeacher,
  value: string,
) => {
  const data = formatFullnameToUppercase(value);
  return searchType === 'main' ? (
    <OptionLabel id={item.id} value={data} />
  ) : (
    <OptionLabel
      styleText={{ fontSize: 16 }}
      styleImg={{ width: 23, height: 23 }}
      id={item.id}
      value={data}
    />
  );
};
